// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__lqUWV","list":"styles_list__22SuZ"};